<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="center">To Barbara, Peter and Rhiannon Lee-Doyle<br/><em>Beannacht Bhandé libh</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?14266c2a